/** @jsxImportSource @emotion/react */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LAYER_TAB_CATEGORIES } from "../../actions/Layers/constants";
import useConfig from "../../actions/Tenants/config/configHook";
import { useTenantPath } from "../../utils/tenantUrl";
import { Loading } from "../Helper/Loading";

/**
 * HomeRedirect component that redirects to the configured home tab
 * This component handles the root "/" route and navigates to the appropriate tab
 * based on the tenant configuration (home_tab field in root_config)
 */
export const HomeRedirect = () => {
    const navigate = useNavigate();
    const config = useConfig();
    const toPath = useTenantPath();

    useEffect(() => {
        // Wait for config to load
        if (!config?.root_config || !config?.stages) {
            return;
        }

        // Get the configured home tab
        const homeTab = config.root_config?.home_tab;

        // Get all available stages/tabs
        const stages = config.stages || [];

        // Find the home tab in available stages
        let targetTab = stages.find((s) => s.value === homeTab);

        // If home tab is not configured or not found, use the first stage
        if (!targetTab) {
            targetTab = stages[0];
        }

        if (targetTab) {
            // Determine the tab category (use the first one if multiple)
            const tabCategory = targetTab?.tab_categories?.[0] || LAYER_TAB_CATEGORIES.OPERATION;

            // Navigate to the tab
            navigate(toPath("layer", `tab/${tabCategory}/${targetTab.value}`), { replace: true });
        } else {
            // Fallback to /layer if no stages are available
            console.error("No stages available for navigation"); // eslint-disable-line no-console
        }
    }, [config?.root_config?.home_tab, config?.stages, navigate]);

    return <Loading />;
};

export default HomeRedirect;
